import request from 'api/request';

export default function readUserRoute(userId) {
  return request({ url: `/users/${userId}` });
}
